import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import CTAButton from '../../components/CTAButton.js'
import { motion } from "framer-motion";
import { HashLink as Link } from 'react-router-hash-link';
import packageJson from '../../../package.json';


import './Pricing.css'
import './MPricing.css'
import { boxvar2_1, boxvar2dyndelay, oPU, sT } from '../../core.js'
import { faPhone, faMagnifyingGlassArrowRight } from '@fortawesome/free-solid-svg-icons';
import PricingCard from '../../components/PricingCard.js'

const CALENDLY = 'https://calendly.com/tonetworkde-meet/getintouch'

const STAND = packageJson.pricingdate

// PAKET Definition auch in Support.js anpassen!
// Bei Änderungen auch den Chatbot anpassen!

const webentwicklung = [
    {
        name: 'Starter',
        price: 'ab 990 €',
        priceNote: 'einmalig',
        forwho: 'Vereine & kleine Auftritte',
        sales: 'Schnell online, professionell und bezahlbar – perfekt für Vereine und alle, die endlich einen neuen Online-Auftritt wollen, ohne dass es kompliziert wird.',
        features: [
            { t: 'bis 3 Seiten', in: null },
            { t: 'Design: Vorlage, individuell angepasst', in: null },
            { t: 'Mobiloptimiert', in: true },
            { t: 'SEO-Grundlagen', in: true },
            { t: 'Kontaktformular', in: false },
            { t: 'Blog / News', in: false },
            { t: 'Shop / Buchung / Login', in: false },
            { t: 'fertig in ~2 Wochen', in: null },
        ],
        paket: 'web-starter',
    },
    {
        name: 'Business',
        badge: '🔥 Beliebt',
        featured: true,
        price: 'ab 2.190 €',
        priceNote: 'einmalig',
        forwho: 'KMU & Veranstalter',
        sales: 'Eure Website soll arbeiten, nicht nur hübsch sein. Individuell gestaltet, auf Google gefunden, gebaut, um Kunden zu gewinnen.',
        features: [
            { t: 'bis 6 Seiten', in: null },
            { t: 'Individuelles Design', in: null },
            { t: 'Mobiloptimiert', in: true },
            { t: 'SEO optimiert', in: true },
            { t: 'Kontaktformular', in: true },
            { t: 'Blog / News', in: true },
            { t: 'Shop / Buchung / Login', in: false },
            { t: '2 Revisionen · fertig in ~4 Wochen', in: null },
        ],
        paket: 'web-business',
    },
    {
        name: 'Plattform',
        price: 'ab 6.900 €',
        priceNote: 'einmalig',
        forwho: 'Individuelle Lösungen',
        sales: 'Du hast Großes vor – Buchungssystem, Mitgliederbereich, Shop? Wir bauen die maßgeschneiderte Lösung, die mit dir wächst.',
        features: [
            { t: 'unbegrenzte Seiten', in: null },
            { t: 'Maßdesign + Branding', in: null },
            { t: 'Mobiloptimiert', in: true },
            { t: 'SEO optimiert', in: true },
            { t: 'Kontaktformular', in: true },
            { t: 'Blog / News', in: true },
            { t: 'Shop / Buchung / Login', in: true },
            { t: '3 Std. Schulung · Termin nach Absprache', in: null },
        ],
        paket: 'web-plattform',
    },
]

const managed = [
    {
        name: 'Care',
        price: '39 €',
        priceNote: 'pro Monat',
        forwho: 'Grundabsicherung',
        sales: 'Deine Website immer sicher, aktuell und schnell – wir kümmern uns, oft bevor du es merkst.',
        features: [
            { t: 'Hosting in Deutschland', in: true },
            { t: 'SSL & Sicherheits-Updates', in: true },
            { t: 'Monitoring (24/7)', in: true },
            { t: 'Regelmäßige Backups', in: false },
            { t: '.de Domain inklusive', in: false },
            { t: 'Kleine Änderungen inklusive', in: false },
            { t: 'Reaktionszeit innerhalb von 3 Werktagen (7-20 Uhr)', in: null },
            { t: 'Fester Ansprechpartner', in: true },
            { t: 'Monatlich kündbar', in: true },
        ],
        paket: 'care',
    },
    {
        name: 'Care Plus',
        badge: '⭐️ Optimal',
        featured: true,
        price: '99 €',
        priceNote: 'pro Monat',
        forwho: 'Der Allrounder',
        sales: 'Sicherheit plus regelmäßige Pflege und schnelle Reaktion – damit deine Seite dauerhaft Top-Form behält.',
        features: [
            { t: 'Hosting in Deutschland', in: true },
            { t: 'SSL & Sicherheits-Updates', in: true },
            { t: 'Monitoring (24/7) mit Benachrichtigungen', in: true },
            { t: 'Regelmäßige Backups', in: true },
            { t: '.de Domain inklusive', in: null },
            { t: '1 Std. Änderungen / Monat', in: true },
            { t: 'Reaktionszeit innerhalb von 2 Werktagen (7-20 Uhr)', in: null },
            { t: 'Fester Ansprechpartner', in: true },
            { t: 'Monatlich kündbar', in: true },
        ],
        paket: 'care-plus',
    },
    {
        name: 'Care Pro',
        price: '199 €',
        priceNote: 'pro Monat',
        forwho: 'Maximale Betreuung',
        sales: 'Persönliche Rundum-Betreuung mit schnellster Reaktion und laufender Optimierung – für alle, die auf ihre Website angewiesen sind.',
        features: [
            { t: 'Hosting in Deutschland', in: true },
            { t: 'SSL & Sicherheits-Updates', in: true },
            { t: 'Monitoring (24/7) mit Benachrichtigungen', in: true },
            { t: 'Regelmäßige Backups', in: true },
            { t: '.de/.com/.eu Domain inklusive', in: true },
            { t: '3 Std. Änderungen / Monat', in: true },
            { t: 'Reaktion am gleichen Tag bei Anfragen vor 17:00 Uhr (7-20 Uhr)', in: null },
            { t: 'Persönlicher Ansprechpartner', in: true },
            { t: 'Monatlich kündbar', in: true },
            { t: '🚨 Notfall-Support am Wochenende und an Feiertagen', in: true },
            { t: '10% Rabatt auf Stundensatz bei Änderungen', in: true },
        ],
        paket: 'care-pro',
    },
]

const fotografie = [
    {
        name: 'Shooting Basic',
        price: 'ab 190 €',
        priceNote: 'einmalig',
        forwho: 'Porträts & Team',
        sales: 'Echte Menschen, echte Wirkung. Professionelle Porträts, die zu dir und deiner Marke passen.',
        features: [
            { t: 'bis 2 Std. Dauer', in: null },
            { t: 'bis 15 bearbeitete Bilder', in: null },
            { t: 'Express-Lieferung optional', in: false },
            { t: 'Nutzungsrechte inklusive', in: true },
        ],
        paket: 'foto-basic',
    },
    {
        name: 'Event-Paket',
        badge: 'Allrounder',
        featured: true,
        price: 'ab 590 €',
        priceNote: 'einmalig',
        forwho: 'Veranstaltungen & Partys',
        sales: 'Eure Veranstaltung verdient Bilder, die die Stimmung einfangen. Wir sind mittendrin – ihr bekommt Fotos, die Lust auf das nächste Event machen.',
        features: [
            { t: 'bis 5 Std. Dauer', in: null },
            { t: 'bis 100 bearbeitete Bilder', in: null },
            { t: 'Express-Lieferung in 48 Std.', in: true },
            { t: 'Nutzungsrechte inklusive', in: true },
        ],
        paket: 'foto-event',
    },
    {
        name: 'Business-Tag',
        price: 'ab 990 €',
        priceNote: 'einmalig',
        forwho: 'Firmen & Produkte',
        sales: 'Ein Tag, alle Motive: Team, Räume, Produkte. Die komplette Bildwelt für euren Auftritt – online wie gedruckt.',
        features: [
            { t: 'ganzer Tag (8 Std.)', in: null },
            { t: 'bis 200 bearbeitete Bilder', in: null },
            { t: 'Express-Lieferung in 48 Std.', in: true },
            { t: 'Nutzungsrechte inklusive', in: true },
            { t: 'Vorgespräche zur Szenen-Gestaltung', in: true },
        ],
        paket: 'foto-business',
    },
]

const content = [
    {
        name: 'Starter DIY',
        price: '290 €',
        priceNote: 'pro Monat',
        forwho: 'Erste Sichtbarkeit',
        sales: 'Regelmäßiger Content auf deinem wichtigsten Kanal – Wir geben die Anleitung und du produzierst den Content selbst.',
        features: [
            { t: '4 Posts / Monat', in: null },
            { t: '1 Reel / Video', in: null },
            { t: 'Plattformen nach Wahl', in: null },
            { t: 'Redaktionsplan', in: true },
            { t: 'Video-Produktion inklusive', in: false },
            { t: 'Community-Management', in: false },
            { t: 'Monatsreport', in: false },
        ],
        paket: 'content-starter',
    },
    {
        name: 'Wachstum',
        badge: '👍🏼 Top Preis-Leistungs',
        featured: true,
        price: '590 €',
        priceNote: 'pro Monat',
        forwho: 'Mehr Reichweite',
        sales: 'Mehr Frequenz, mehr Bewegtbild, mehr Interaktion – der Hebel für spürbares Wachstum. Mit unserer Anleitung produzierst du den Content ganz einfach selbst.',
        features: [
            { t: '8 Posts / Monat', in: null },
            { t: '4 Reels / Videos', in: null },
            { t: 'Plattformen: Instagram, Facebook, TikTok', in: null },
            { t: 'Redaktionsplan', in: true },
            { t: 'Video-Produktion inklusive', in: false },
            { t: 'Basic Community-Management (einfache Reaktionen)', in: true },
            { t: 'Monatsreport', in: true },
        ],
        paket: 'content-wachstum',
    },
    {
        name: 'Vollgas',
        price: '1.490 €',
        priceNote: 'pro Monat',
        forwho: 'Maximale Präsenz',
        sales: 'Hohe Schlagzahl über mehrere Kanäle inkl. Strategie – wenn Social Media euer zentraler Wachstumstreiber ist.',
        features: [
            { t: '14 Posts bzw. Stories / Monat', in: null },
            { t: '8 Reels / Videos', in: null },
            { t: 'Plattformen: Instagram, Facebook, TikTok, YouTube, LinkedIn', in: null },
            { t: 'Redaktionsplan', in: true },
            { t: 'Video-Produktion optional', in: true },
            { t: 'Community-Management', in: true },
            { t: 'Aktives Kommentieren für mehr Engagement', in: true },
            { t: 'Monatsreport + regelmäßige Strategieberatung', in: true },
        ],
        paket: 'content-vollgas',
    },
]

const weitereLeistungen = [
    { name: 'Appentwicklung', tag: 'Software', price: 'ab 4.900 €', priceNote: 'einmalig', line: 'Deine Idee als App – intuitiv, performant und zukunftssicher. Für Kunden, Mitarbeiter oder interne Prozesse.', href: '/services/appdev', cta: 'Zur eigenen App' },
    { name: 'Serverhosting', tag: 'Software', price: 'ab 19 €', priceNote: 'pro Monat', line: 'Verlässlich, sicher und Made in Germany.', href: '/services/hosting', cta: 'Zum Hosting' },
    { name: 'KI-Beratung', tag: 'Beratung', price: 'ab 790 €', priceNote: 'pro Workshop', line: 'Wir zeigen dir, wo KI dir konkret Zeit spart – kein Hype, sondern messbarer Nutzen für deinen Alltag.', href: '/services/ai', cta: 'Zur KI-Power' },
    { name: 'Branding / Logo', tag: 'Media', price: 'ab 490 €', priceNote: 'einmalig', line: 'Ein Auftritt, den man wiedererkennt. Wir entwickeln eine Designsprache, die zu deiner Marke passt.', href: '/support?paket=branding', cta: 'Branding anfragen' },
    { name: 'Individuelles Projekt', tag: 'Sonderlösung', price: 'auf Anfrage', priceNote: '', line: 'Du hast eine ungewöhnliche Idee? Wir lieben sowas und entwickeln deine individuelle Sonderlösung.', href: '/support?paket=sonderloesung', cta: 'Jetzt anfragen' },
]

const bundles = [
    {
        name: 'Verein-Komplett',
        price: 'ab 1.290 €',
        priceExtra: '+ 29 € / Monat',
        contains: 'Website (Starter) + Logo-Auffrischung + Care-Betreuung',
        sales: 'Alles, was euer Verein online braucht – zum fairen Ehrenamtspreis.',
        paket: 'bundle-verein',
    },
    {
        name: 'KMU-Wachstum',
        badge: '🔥 Beliebtes Bundle',
        featured: true,
        price: 'ab 2.490 €',
        priceExtra: '+ 99 € / Monat',
        contains: 'Website (Business) + Business-Foto-Tag + Care Plus',
        sales: 'Der Rundum-Start für Unternehmen, die online durchstarten wollen.',
        paket: 'bundle-kmu',
    },
    {
        name: 'Event-Boost',
        price: 'ab 1.490 €',
        priceExtra: 'einmalig',
        contains: 'Event-Landingpage + Event-Fotopaket + 1 Monat Social Content (Starter DIY)',
        sales: 'Euer Event online ausverkauft – Webseite, Bilder und Reichweite im Komplettpaket.',
        paket: 'bundle-event',
    },
]

const faqs = [
    {
        q: 'Mein Budget ist zu gering – geht das trotzdem?',
        a: 'Sehr wahrscheinlich ja. Sag uns einfach, welches Budget zur Verfügung steht – wir finden gemeinsam eine Lösung und setzen das Wichtigste zuerst um. Für gemeinnützige Vereine, kleine Veranstalter und Startups haben wir besonders faire Konditionen (Care-Betreuung z.B. bereits ab 29 €/Monat).',
    },
    {
        q: 'Sind das Festpreise?',
        a: 'Nein. Alle hier genannten Beträge sind Listenpreise ohne Rabatte und zeigen den Einstieg ("ab"). Nach einem kurzen Gespräch erhältst du ein verbindliches Festangebot, das individuell auf dich zugeschnitten ist – ohne versteckte Kosten. Alternativ bieten wir dir auch Leistungen nach Stundensatz - auch hier kommunizieren wir transparent.',
    },
    {
        q: 'Bin ich an ein Abo gebunden?',
        a: 'Nein. Unsere Care-Pakete sind monatlich kündbar. Wir wollen dich überzeugen, nicht festhalten.',
    },
    {
        q: 'Was ist, wenn ich später mehr brauche?',
        a: 'Du wechselst jederzeit das Paket – wir wachsen mit dir. Alternativ bieten wir dir auch Änderungen oder Services nach Stundensatz - das gilt auch wenn die Anforderung die Leistungen des Pakets überschreiten würde.',
    },
]

/* -------------------------------------------------------------------------- */

function PricingSection({ id, subtitle, title, lead, tiers }) {
    return (
        <motion.div
            variants={boxvar2_1}
            initial="hidden"
            exit="hidden"
            whileInView="visible"
            viewport={{ once: false, margin: "-50px" }}
            className="pricing_section"
            id={id}
        >
            <h2>{title}</h2>
            {subtitle && <h3>{subtitle}</h3>}
            {lead && <p className="pricing_lead">{lead}</p>}
            <div className="pricing_grid">
                {tiers.map((t, i) => <PricingCard key={t.name} tier={t} delay={0.15 * (i + 1)} />)}
            </div>
            <p className="pricing_note">
                {/* Alle Preise netto, zzgl. MwSt. – <b>Listenpreise ohne Rabatte</b>. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND} */}
                Alle Preise netto, zzgl. MwSt. – Listenpreise ohne Rabatte. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND}
            </p>
        </motion.div>
    )
}

export default function Pricing() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"pricing"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Preise & Pakete – ToNetwork</title>
                <link rel="canonical" href="https://tonetwork.de/pricing" />
                <meta name="description" content="Transparente Preise von ToNetwork: Webentwicklung, Website-Betreuung, Fotografie, Content & Bundles. Listenpreise ohne Rabatte – jedes Paket wird individuell angepasst." />
                <meta property="og:title" content="Transparente Preise – ToNetwork" />
                <meta property="og:description" content="Was kostet was? Hier siehst du unsere Listenpreise für Web, Betreuung, Foto & Content – individuell anpassbar." />
                <meta property="og:url" content="https://tonetwork.de/pricing" />
            </Helmet>

            <section className='sec_next' id='sec_next--pricing'>
                <div className='sec_next_cont' id="sec_next--pricing--cont" style={{ wordBreak: "break-word" }}>

                    {/* ---------- Intro ---------- */}
                    <motion.div variants={boxvar2_1} className='about_section_cont pricing_intro' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Transparente Preise. Keine Überraschungen.</h2>
                        <h3>Du siehst, was es kostet – und was du bekommst.</h3>
                        <p>
                            Die meisten Agenturen verstecken ihre Preise. Wir nicht. Du startest mit einem Projekt und
                            entscheidest selbst, ob wir dich danach langfristig betreuen – fair, planbar, ohne Kleingedrucktes.
                            Übrigens: Gemeinnützige Vereine erhalten bei uns besonders faire Konditionen.
                        </p>

                        {/* prominenter Hinweis: Listenpreise ohne Rabatte, individuell */}
                        {/* <div className="pricing_disclaimer">
                            <b>Wichtig:</b> Alle angegebenen Beträge sind <b>Listenpreise ohne Rabatte</b> und dienen der Orientierung
                            („ab"-Preise). Jedes Paket wird in einem persönlichen Gespräch <b>individuell auf dein Projekt zugeschnitten</b> –
                            dein verbindliches Festangebot kann je nach Umfang abweichen.
                        </div> */}

                        <br />
                        <CTAButton className="" showArrow={false} customIcon={faPhone} iconLeft={true} title={"Termin vereinbaren"} onclick={() => { oPU(CALENDLY) }} />
                    </motion.div>

                    {/* ---------- Anker-Navigation ---------- */}
                    <motion.div variants={boxvar2_1} className='pricing_anchornav noselect' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <button type="button" onClick={() => sT('#pricing-web')}>Webentwicklung</button>
                        <button type="button" onClick={() => sT('#pricing-betreuung')}>Betreuung</button>
                        <button type="button" onClick={() => sT('#pricing-foto')}>Foto</button>
                        <button type="button" onClick={() => sT('#pricing-content')}>Content</button>
                        <button type="button" onClick={() => sT('#pricing-weitere')}>Weitere Leistungen</button>
                        <button type="button" onClick={() => sT('#pricing-bundles')}>Bundles</button>
                    </motion.div>

                    {/* ---------- 1. Webentwicklung (einmalig) ---------- */}
                    <PricingSection
                        id="pricing-web"
                        title="Webentwicklung"
                        subtitle="Einmalige Erstellung"
                        lead={
                            <>
                                Eine Website, die arbeitet: modern, schnell und auf Google gefunden. Die mittlere Stufe ist unsere meistgewählte. Alternativ bieten wir dir auch die Möglichkeit eines{' '}
                                <Link to='/services/webdev#webdev-abo'>
                                    'Web-Abo'
                                </Link>.

                            </>
                        }

                        tiers={webentwicklung}
                    />

                    {/* ---------- 2. Managed Service (monatlich) ---------- */}
                    <PricingSection
                        id="pricing-betreuung"
                        title="Website-Betreuung"
                        subtitle="Monatliche Betreuung"
                        lead="Eine Website ist kein Möbelstück – sie braucht Pflege. Andere bauen und verschwinden, wir bleiben: sicher, aktuell, schnell – mit festem Ansprechpartner, der dich beim Namen kennt."
                        tiers={managed}
                    />

                    {/* ---------- 3. Fotografie ---------- */}
                    <PricingSection
                        id="pricing-foto"
                        title="Fotografie"
                        subtitle="Einmalige Shootings"
                        lead="Bilder sagen mehr als Worte – vor allem, wenn sie professionell inszeniert sind. Deine Veranstaltung können wir ganz individuell begleiten. Als Anhaltspunkt kannst du dir die Preise für unsere Pakete ansehen."
                        tiers={fotografie}
                    />

                    {/* ---------- 4. Content / Social Media ---------- */}
                    <PricingSection
                        id="pricing-content"
                        title="Content & Social Media"
                        subtitle="Monatliche Pakete"
                        lead="Reichweite, die nicht ständig Geld kostet. Bezahlte Anzeigen sind weg, sobald das Budget aus ist – guter Content bleibt."
                        tiers={content}
                    />

                    {/* ---------- 5. Weitere Leistungen ---------- */}
                    <motion.div variants={boxvar2_1} className="pricing_section" id="pricing-weitere" initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Weitere Leistungen</h2>
                        <h3>Unser komplettes Spektrum – aus einer Hand.</h3>
                        <div className="pricing_grid">
                            {weitereLeistungen.map((l, i) => (
                                <motion.div
                                    key={l.name}
                                    variants={boxvar2dyndelay}
                                    custom={0.15 * (i + 1)}
                                    initial="hidden"
                                    exit="hidden"
                                    whileInView="visible"
                                    viewport={{ once: false, margin: "-50px" }}
                                    className="pricing_card pricing_card-simple"
                                >
                                    <h3 className="pricing_card_name">{l.name}</h3>
                                    <div><span className="servicetype_tag">{l.tag}</span></div>
                                    <div className="pricing_price">
                                        <span className="pricing_price_value">{l.price}</span>
                                        {l.priceNote && <span className="pricing_price_note">{l.priceNote}</span>}
                                    </div>
                                    <p className="pricing_card_sales">{l.line}</p>
                                    <CTAButton className="pricing_card_cta" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={l.cta} href={l.href} />
                                </motion.div>
                            ))}
                        </div>
                        <p className="pricing_note">
                            {/* Alle Preise netto, zzgl. MwSt. – <b>Listenpreise ohne Rabatte</b>. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND} */}
                            Alle Preise netto, zzgl. MwSt. – Listenpreise ohne Rabatte. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND}
                        </p>
                    </motion.div>

                    {/* ---------- 6. Bundles ---------- */}
                    <motion.div variants={boxvar2_1} className="pricing_section" id="pricing-bundles" initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Spar-Pakete</h2>
                        <h3>Mehr aus einer Hand, weniger Aufwand für dich.</h3>
                        <div className="pricing_grid">
                            {bundles.map((b, i) => (
                                <motion.div
                                    key={b.name}
                                    variants={boxvar2dyndelay}
                                    custom={0.15 * (i + 1)}
                                    initial="hidden"
                                    exit="hidden"
                                    whileInView="visible"
                                    viewport={{ once: false, margin: "-50px" }}
                                    className={'pricing_card' + (b.featured ? ' pricing_card-featured' : '')}
                                >
                                    {b.badge && <span className="pricing_badge">{b.badge}</span>}
                                    <h3 className="pricing_card_name">{b.name}</h3>
                                    <div className="pricing_price">
                                        <span className="pricing_price_value">{b.price}</span>
                                        <span className="pricing_price_note">{b.priceExtra}</span>
                                    </div>
                                    <p className="pricing_bundle_contains">{b.contains}</p>
                                    <p className="pricing_card_sales">{b.sales}</p>
                                    <CTAButton className="pricing_card_cta" showArrow={true} title={'Bundle anfragen'} href={'/support?paket=' + b.paket} />
                                </motion.div>
                            ))}
                        </div>
                        <p className="pricing_note">
                            {/* Alle Preise netto, zzgl. MwSt. – <b>Listenpreise ohne Rabatte</b>. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND} */}
                            Alle Preise netto, zzgl. MwSt. – Listenpreise ohne Rabatte. Jedes Paket wird individuell auf dein Projekt zugeschnitten. Stand: {STAND}
                        </p>
                    </motion.div>

                    {/* ---------- 7. FAQ ---------- */}
                    <motion.div variants={boxvar2_1} className="pricing_section" id="pricing-faq" initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Häufige Fragen</h2>
                        <div className="pricing_faq_list">
                            {faqs.map((f, i) => (
                                <details key={i} className="pricing_faq_item" open={i === 0}>
                                    <summary>{f.q}</summary>
                                    <p>{f.a}</p>
                                </details>
                            ))}
                        </div>
                    </motion.div>

                    {/* ---------- Abschluss-CTA ---------- */}
                    <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                        <div className='small_services_textbox'>
                            {/* <h3>&lt;Noch unsicher, welches Paket passt?/&gt;</h3> */}
                            <h3>Noch unsicher, welches Paket passt?</h3>
                            <br />
                            <p>
                                Kein Problem. In einem kostenlosen 30-Minuten-Gespräch finden wir gemeinsam heraus, was du wirklich
                                brauchst – ehrlich und ohne Verkaufsdruck. Und denk dran: Alle Preise hier sind Listenpreise ohne
                                Rabatte und werden individuell für dich ausgestaltet.
                            </p>
                            <CTAButton className="" showArrow={false} customIcon={faPhone} iconLeft={true} title={"Kostenloses Erstgespräch"} onclick={() => { oPU(CALENDLY) }} />
                            <br />
                            <p className='pricing_toni_hint'>
                                Erst Orientierung gefragt? <a href='/chat'>ToNi beantwortet Fragen zu Paketen und Preisen</a> – unverbindlich im Chat.
                            </p>
                        </div>
                    </motion.div>

                    {/* <p className="pricing_footnote">
                        Stand: {STAND}. Alle Preise netto (zzgl. gesetzl. MwSt.) und als Orientierung zu verstehen.
                        Es handelt sich um Listenpreise ohne Rabatte; das verbindliche Angebot wird individuell erstellt.
                    </p> */}
                    <p className="pricing_footnote">
                        Es gelten unsere <a href='/rechtliches/agb'>Allgemeinen Geschäftsbedingungen (AGB)</a>
                    </p>

                    <br /><br /><br />
                </div>
            </section>

            <MainFooter />
        </div>
    )
}
